import DataStore from '@/engine/stores/data-store';

class TemplateDataStore extends DataStore {

}

export default new TemplateDataStore();
